import {
  inv01_2026,
  inv02_2026,
  inv03_2026,
  inv04_2026,
  inv05_2026,
  inv06_2026,
  inv07_2026,
  inv08_2026,
  // inv_itp_01,
  inv09_2026,
  inv10_2026,
  inv11_2026,
  inv12_2026,
  inv13_2026,
  inv14_2026,
  inv15_2026,
  inv16_2026,
  inv17_2026,
  inv18_2026,
  inv19_2026,
  inv20_2026,
  inv_itp_01,
  //inv21_2026,

  // inv22_2025,
  // inv23_2025,
  // inv_itp_02,
} from "../../json/anioInvitaciones/2026/anioInvitacion2026";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CAASIM-HGO-INV3-OP-01-2026":
      datosSeleccionados = inv01_2026;
      break;
    case "CAASIM-HGO-INV3-OP-02-2026":
      datosSeleccionados = inv02_2026;
      break;
    case "CAASIM-HGO-INV3-OP-03-2026":
      datosSeleccionados = inv03_2026;
      break;
    case "CAASIM-HGO-INV3-OP-04-2026":
      datosSeleccionados = inv04_2026;
      break;
    case "CAASIM-HGO-INV3-OP-05-2026":
      datosSeleccionados = inv05_2026;
      break;
    case "CAASIM-HGO-INV3-OP-06-2026":
      datosSeleccionados = inv06_2026;
      break;
    case "CAASIM-HGO-INV3-OP-07-2026":
      datosSeleccionados = inv07_2026;
      break;
    case "CAASIM-HGO-INV3-OP-08-2026":
      datosSeleccionados = inv08_2026;
      break;
    case "CAASIM-HGO-INV3-OP-09-2026":
      datosSeleccionados = inv09_2026;
      break;
    case "CAASIM-HGO-INV3-OP-10-2026":
      datosSeleccionados = inv10_2026;
      break;
    case "CAASIM-HGO-INV3-OP-11-2026":
      datosSeleccionados = inv11_2026;
      break;
    case "CAASIM-HGO-INV3-OP-12-2026":
      datosSeleccionados = inv12_2026;
      break;
    case "CAASIM-HGO-INV3-OP-13-2026":
      datosSeleccionados = inv13_2026;
      break;
    case "CAASIM-HGO-INV3-OP-14-2026":
      datosSeleccionados = inv14_2026;
      break;
    case "CAASIM-HGO-INV3-OP-15-2026":
      datosSeleccionados = inv15_2026;
      break;
    case "CAASIM-HGO-INV3-OP-16-2026":
      datosSeleccionados = inv16_2026;
      break;
    case "CAASIM-HGO-INV3-OP-17-2026":
      datosSeleccionados = inv17_2026;
      break;
    case "CAASIM-HGO-INV3-OP-18-2026":
      datosSeleccionados = inv18_2026;
      break;
    case "CAASIM-HGO-INV3-OP-19-2026":
      datosSeleccionados = inv19_2026;
      break;
    case "CAASIM-HGO-INV3-OP-20-2026":
      datosSeleccionados = inv20_2026;
      break;
    case "ITP-CAASIM-SRMySG-SAL-01-2026":
      datosSeleccionados = inv_itp_01;
      break;

    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
